const searchStrip = {
  hotels: "Hotels", // translated
  city: "Stad", // translated
  checkIn: "Check in", // translated
  checkOut: "Uitchecken", // translated
  date: "Datum", // translated
  persons: "Personen", // translated
  adults: "volwassenen", // translated
  rooms: "Kamers", // translated
  editSearch: "Zoekopdracht bewerken", // translated
  newSearch: "Nieuwe zoekopdracht", // translated
  listView: "Lijstweergave", // translated
  mapView: "Kaartweergave", // translated
};


export default searchStrip;
